<div class="navigator" *ngIf="itinerary">
	<button class="btn btn-primary btn-circle-icon text-light"
		(click)="gotoPrevDay()"
		[disabled]="!itinerary?.results || !currentDay || currentDay == 1 || !prevDest.destinationSlugPath"
		>
		<fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
	</button>

	<div class="d-flex align-items-center mx-2">
		<button class="btn btn-primary btn-circle-icon text-light mr-2"
			(click)="openPanel()"
			>
			<fa-icon [icon]="['fas', 'list']"></fa-icon>
		</button>
		<div>
			<div class="font-weight-medium">
				<span *ngIf="!currentDay">Itinerary</span>
				<span *ngIf="currentDay">Day {{currentDay}}</span>
			</div>
			<div class="text-light text-small o-50">{{arriveDate | date: 'MMM d, y'}}</div>
		</div>
		
	</div>

	<button class="btn btn-primary btn-circle-icon text-light"
		(click)="gotoNextDay()"
		[disabled]="!itinerary?.results || currentDay == itinerary.results.length || !nextDest?.destinationSlugPath"
		>
		<fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
	</button>
</div>


<div class="navigator-panel content" *ngIf="showNavigatorPanel">

	<div class="navigator-panel-bg" (click)="closePanel();"></div>

	<div class="navigator-panel-content text-secondary">
		<div class="d-flex">
			<a (click)="closePanel(); _itineraryService.clearItinerary()" 
				[routerLink]="['/cruises/' + itinerary.searchUrl.cruiseLine + '/' +  itinerary.searchUrl.shipName]" 
				[queryParams]="{date: itinerary.searchUrl.sailDate, codeToCruiseId: itinerary.codeToCruiseId}"
				class="btn btn-link pl-0 pt-0 underline-onhover" >
				<fa-icon [icon]="['fas', 'chevron-left']" class="mr-2"></fa-icon>
				<span>Overview</span>
			</a>

			<button type="button" class="panel-close ml-auto" aria-label="Close" (click)="closePanel()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>
		</div>


		<h2 class="font-weight-bold font-family-accents mb-3">Your Itinerary</h2>

		<ng-container *ngIf="showNavigatorPanel">

			<div class="text-uppercase font-weight-bold text-small text-gray-600 mb-2">Cruise Details</div>
			<div class="mb-3 bg-blue-mist rounded-corners px-4 py-3">
				<div class="mb-2">
					<span class="font-weight-bold mr-2">Cruise Line:</span>
					<span>{{itinerary.cruiseLineName}}</span>
				</div>
				<div class="mb-2">
					<span class="font-weight-bold mr-2">Ship:</span>
					<span>{{itinerary.shipName}}</span>
				</div>
				<div class="mb-0">
					<span class="font-weight-bold mr-2">Sail Dates:</span>
					<span>{{itinerary.sailDate | date: 'MMMM d, yyyy'}}</span>
					<span class="mx-2">&ndash;</span>
					<span>{{itinerary.results.length}} NIGHTS</span>
				</div>
			</div>

			<div class="mb-3">
				<a (click)="closePanel(); _itineraryService.clearItinerary()" 
					[routerLink]="['/cruises']" 
					class="btn btn-link text-gray-600 pl-0 underline-onhover" >
					<fa-icon [icon]="['fas', 'sync']" class="mr-2"></fa-icon>
					<span>Change Itinerary</span>
				</a>
				<a class="btn btn-link text-gray-600 underline-onhover"
					(click)="deleteItinerary()"
					href="javascript:void(0);">
					<fa-icon [icon]="['far', 'calendar-times']" class="mr-2"></fa-icon>
					<span>Delete Itinerary</span>
				</a>
			</div>

			<a class="itinerary-result d-flex  text-secondary underline-onhover" 
				*ngFor="let item of itinerary.results; let i = index; let first = first; let last = last;"
				[routerLink]="[item.destinationSlugPath]"
				[queryParams]="{date: item.arriveDateStr}"
				(click)="closePanel();"
				>

				<div class="day text-gray-600 body-size">DAY {{item.day}}</div>
				<div class="info">
					<div class="date text-gray-600 body-size">{{item.arriveDate | date: 'EEE, MMMM d' | uppercase}}</div>
					<h3 class="name font-family-accents font-weight-bold mb-2">{{item.name}}</h3>
					<div class="time" *ngIf="last">
						<span class="font-weight-bold">Arrives: </span>
						<span class="">{{item.arriveTimeFormatted}}</span>
					</div>
					<div class="time" *ngIf="first">
						<span class="font-weight-bold">Departs: </span>
						<span class="">{{item.departTimeFormatted}}</span>
					</div>
					<div class="time" *ngIf="!last && !first">
						<span class="font-weight-bold">From: </span>
						<span class="">{{item.arriveTimeFormatted}}</span>
						<span class="mx-2">&ndash;</span>
						<span class="">{{item.departTimeFormatted}}</span>
					</div>
				</div>

			</a>

		</ng-container>

	</div>


</div>